import { Component, Inject, Input, OnInit } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { DialogData } from '../consulta-inspecciones/consulta-inspecciones.component';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
//import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-dialogo-eliminar-averias',
    templateUrl: './dialogo-eliminar-averias.component.html',
    styleUrls: ['./dialogo-eliminar-averias.component.css'],
    standalone: true,
    imports: [FormsModule,CommonModule,NbCardModule,NbIconModule,DropdownModule,MatCardModule],
})
export class DialogoEliminarAveriasComponent implements OnInit {


  constructor(public dialogRef: MatDialogRef<DialogoEliminarAveriasComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit(): void {
  }

  actualizarEstado(estado:boolean){
    this.dialogRef.close(estado);
  }

}
